/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalsWrapper_org = {
    readonly userGoals: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly goalId: string;
                readonly name: string;
                readonly isDeleted: boolean;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"EmailTriageGoal_org" | "FocusTimeGoal_org" | "MeetingReliefGoal_org">;
    readonly " $refType": "GoalsWrapper_org";
};
export type GoalsWrapper_org$data = GoalsWrapper_org;
export type GoalsWrapper_org$key = {
    readonly " $data"?: GoalsWrapper_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"GoalsWrapper_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GoalsWrapper_org",
    "selections": [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000000
                }
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "userGoals",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "goalId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isDeleted",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": "userGoals(first:1000000)"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EmailTriageGoal_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FocusTimeGoal_org"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MeetingReliefGoal_org"
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = 'e76d9f0a3e01058ae24c5246e947d779';
export default node;
